module.exports = __webpack_public_path__ + "fonts/MergeOne-Regular.6e2b0ea5.ttf";